export class LinkData {
  fragment?: string;
  href?: string;
  linkName?: string;
  tracking?: string[];
}
